import { loader } from './reducers';
export default loader;
